import { MADERA_BACKOFFICE_PATHS } from "constants/constants";
import { Navigate, Outlet } from "react-router-dom";
import { isTokenAvailable } from "utilities/storageUtilities";
import { isHMIToken } from "utilities/utilities";

export const ProtectedOsornoRoute = ({
    redirectPath = `/${MADERA_BACKOFFICE_PATHS.ROOT_PATH}/${MADERA_BACKOFFICE_PATHS.LOGIN}`,
}: {
    redirectPath?: string;
}) => {
    const token = isTokenAvailable();

    if (!token) {
        return <Navigate to={redirectPath} replace />;
    }

    if (isHMIToken()) {
        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />;
};
